import { IWork, IWorkCreate, IWorkUpdate } from '../typing/work.interface';

export class Work {
    data: IWork;

    constructor(data: IWork){
        this.data = data;
    }

    dataForCreate(formData: IWorkCreate): IWorkCreate{
        return {
            projectId: formData.projectId,
            name: formData.name
        };
    }

    dataForUpdate(formData: IWorkCreate): IWorkUpdate {
        return {
            projectId: formData.projectId,
            id: this.data.id,
            name: formData.name
        };
    }

    formData(): IWorkCreate {
        return {
            projectId: this.data.project?.id,
            name: this.data.name,
        };
    }
}
